import { __assign, __awaiter, __generator } from "tslib";
import { writable } from "svelte/store";
import { ApiClient, pageHandler } from "../GlobalHelper/ApiClient";
function createPlayerStore() {
    var _this = this;
    var _a = writable({
        players: null,
        player: null
    }), subscribe = _a.subscribe, set = _a.set, update = _a.update;
    return {
        subscribe: subscribe,
        update: update,
        getFirstPage: function (playerStore) { return __awaiter(_this, void 0, void 0, function () {
            var client, page_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = ApiClient.getInstance();
                        if (!client) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.playerClient
                                .listPlayers(pageHandler(playerStore.players, "first"))
                                .then(function (result) {
                                return result;
                            })["catch"](function (error) {
                                console.log("error", error);
                                return null;
                            })];
                    case 1:
                        page_1 = _a.sent();
                        update(function (store) {
                            return __assign(__assign({}, store), { players: page_1 });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        getLastPage: function (playerStore) { return __awaiter(_this, void 0, void 0, function () {
            var client, page_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = ApiClient.getInstance();
                        if (!client) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.playerClient
                                .listPlayers(pageHandler(playerStore.players, "last"))
                                .then(function (result) {
                                return result;
                            })["catch"](function (error) {
                                console.log("error", error);
                                return null;
                            })];
                    case 1:
                        page_2 = _a.sent();
                        update(function (store) {
                            return __assign(__assign({}, store), { locations: page_2 });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        getNextPage: function (playerStore) { return __awaiter(_this, void 0, void 0, function () {
            var client, page_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = ApiClient.getInstance();
                        if (!client) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.playerClient
                                .listPlayers(pageHandler(playerStore.players, "next"))
                                .then(function (result) {
                                return result;
                            })["catch"](function (error) {
                                console.log("error", error);
                                return null;
                            })];
                    case 1:
                        page_3 = _a.sent();
                        update(function (store) {
                            return __assign(__assign({}, store), { locations: page_3 });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        getPrevPage: function (playerStore) { return __awaiter(_this, void 0, void 0, function () {
            var client, page_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = ApiClient.getInstance();
                        if (!client) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.playerClient
                                .listPlayers(pageHandler(playerStore.players, "previous"))
                                .then(function (result) {
                                return result;
                            })["catch"](function (error) {
                                console.log("error", error);
                                return null;
                            })];
                    case 1:
                        page_4 = _a.sent();
                        update(function (store) {
                            return __assign(__assign({}, store), { locations: page_4 });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        getSelfPage: function () { },
        getPageNumbered: function (playerStore, pageNumber) { return __awaiter(_this, void 0, void 0, function () {
            var client, page_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        client = ApiClient.getInstance();
                        if (!client) return [3 /*break*/, 2];
                        return [4 /*yield*/, client.playerClient
                                .listPlayers(pageHandler(playerStore.players, pageNumber))
                                .then(function (result) {
                                return result;
                            })["catch"](function (error) {
                                console.log("error", error);
                                return null;
                            })];
                    case 1:
                        page_5 = _a.sent();
                        update(function (store) {
                            return __assign(__assign({}, store), { locations: page_5 });
                        });
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); },
        setPageSize: function (size) { }
    };
}
export var playerStore = createPlayerStore();
